import React from 'react';
import styles from './styles.module.css';

const ContainerInfoRow = ({ informations, tableData }) => {
  const data = tableData || {};

  return (
    <div className={styles.infoRow}>
      {informations.map((info, index) => (
        <div
          key={index}
          className={styles.autobookInfoFlexP}
          style={{ flex: info.flex }}>
          <span className={styles.title}>{info.label}: </span>
          <span className={styles.value}>{data[info.field] ?? '-'}</span>
        </div>
      ))}
    </div>
  );
};

export default ContainerInfoRow;
